"use client";

import { useLingui } from "@lingui/react/macro";
import { Button, FormInput } from "@offstreetparking/design-system/forms";
import { Heading, Text } from "@offstreetparking/design-system/typography";
import { Form } from "@offstreetparking/portal-flow/components/forms/Form";
import { ButtonRow } from "@offstreetparking/portal-flow/components/layouts/ButtonRow";
import type { TRPCClientErrorLike } from "@trpc/client";
import { useId } from "react";
import { useZod } from "~/components/providers/TranslationsProvider";
type CodeStepProps = {
	isPending: boolean;
	error: TRPCClientErrorLike<any> | null;
	onSubmit: (code: string) => void;
};
export const CodeStep = ({ isPending, error, onSubmit }: CodeStepProps) => {
	const z = useZod();
	const { t } = useLingui();
	const formId = useId();
	return (
		<Form
			id={formId}
			className="space-y-4 p-8"
			schema={z.object({
				code: z.string().min(1),
			})}
			serverError={error}
			onSubmit={({ code }) => onSubmit(code)}
		>
			<Heading>{t`Enter Code`}</Heading>
			<FormInput
				name="code"
				label={t`Registration code`}
				placeholder={t`Enter registration code`}
				isRequired
				type="password"
				toggleAriaLabel={t`Registration code`}
			/>
			<div>
				<Text size="md" className="font-bold text-primary">
					{t`Can't find the code?`}
				</Text>
				<Text size="sm" className="mt-2">
					{t`Check with the location operator for the correct registration code.`}
				</Text>
			</div>
			<ButtonRow>
				<Button isLoading={isPending} type="submit" form={formId} className="w-full text-base md:w-[160px]">
					{t`Lookup`}
				</Button>
			</ButtonRow>
		</Form>
	);
};
